import { render, staticRenderFns } from "./bread.vue?vue&type=template&id=fcab9e5c&scoped=true&"
import script from "./bread.vue?vue&type=script&lang=js&"
export * from "./bread.vue?vue&type=script&lang=js&"
import style0 from "./bread.vue?vue&type=style&index=0&id=fcab9e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab9e5c",
  null
  
)

export default component.exports